/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { StickyContainer, Sticky } from "react-sticky";

/* components */
import PagesForm from "./PagesForm";
import Page from "../../shared/Page";
import Loader from "../../ui/Loader";
import parseAppKey from "../../../helpers/routeHelpers/parseAppKey";

import * as constants from "../../../constants";

import GetItem from "../../../helpers/dataProviders/getItem";

class PageFormWrapper extends Component {
	constructor(props) {
		super(props);
		this.indefiniteArticle = "A";
		this.label = "Page";
		this.id = props.match.params.id ? props.match.params.id : 0;

		this.initialPageId = "5bfc77d83dde002fec72a49c";

		this.state = {
			item: null,
			appetizePageId: null,
			appetizeParams: encodeURIComponent(`{"firestorePageDocumentName": "${this.initialPageId}", "appId": null}`),
			appId: null,
			showPreview: false,
			responsivePreview: false,
			moduleId: null,
			appetizePaused: false,
		};
	}

	componentDidMount() {
		this.setAppId();
	}

	setAppId = () => {
		if (this.props.apps) {
			let appId = this.props.apps.find(app => app.key === parseAppKey()).id;
			this.setState({ appId });
		}
	};

	shouldComponentUpdate(nextProps) {
		const { match } = this.props;
		const { appId } = this.state;
		let { id } = match.params;
		let newId = nextProps.match.params.id;
		if (!appId) {
			this.setAppId();
		}
		if (id !== newId) {
			if (newId) {
				this.props.showLoading();
				this.props.clearFormApi();
				const appetizeId = newId + "-" + this.props.auth.user.uid;
				GetItem(`/pages/${newId}`)
					.then(data => {
						this.setState({
							item: data.data,
							showPreview: true,
							appetizeParams: encodeURIComponent(
								`{"firestorePageDocumentName": "${appetizeId}", "appId": "${appId}"}`
							),
							moduleId: data.data.moduleId,
						});
						if (this.props.hasFormApi) {
							this.props.formApi.setValues(data.data);
						}
						this.props.hideLoading();
					})
					.catch(() => {
						this.props.hideLoading();
					});
			} else {
				this.props.showLoading();
				setTimeout(() => {
					this.setState({
						item: null,
						appetizePageId: null,
						showPreview: false,
						moduleId: null,
						appetizeParams: encodeURIComponent(
							`{"firestorePageDocumentName": "${this.initialPageId}", "appId": "${appId}"}`
						),
					});
					this.props.hideLoading();
				}, 200);
			}
		}

		return true;
	}

	submitForm(values, submitHandler, id = "") {
		const { createItem, copyItem, updateItem, type } = this.props;
		switch (type) {
			case "new":
				createItem(values, submitHandler);
				break;
			case "copy":
				copyItem(values, submitHandler);
				break;
			case "update":
				updateItem(values, submitHandler, id);
				break;
			default:
				break;
		}
	}

	renderCreateForm = () => {
		if (this.state.item === null) {
			GetItem(`/apps/${this.props.appKey}`).then(data => {
				this.setState({ item: { themeId: data.data.primaryThemeId } });
			});
		}
		return (
			<div className="ta-center">
				{this.state.item ? (
					<PagesForm
						cultures={this.props.cultures}
						onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler)}
						buttonLabel={`Create ${this.label}`}
						getFormApi={this.props.getFormApi}
						hasFormApi={this.props.hasFormApi}
						setAppetizePageId={this.setAppetizePageId}
						setAppetizePause={this.setAppetizePause}
						appKey={this.props.appKey}
						initialValues={this.state.item}
						filteredModules={this.props.modules.modules}
					/>
				) : (
					<Loader />
				)}
			</div>
		);
	};

	renderCopyForm = () => {
		if (this.state.item === null) {
			GetItem(`/pages/${this.props.match.params.id}`).then(data => {
				this.sanitizePageValues(data.data);
			});
		} else if (this.state.item.id !== this.props.match.params.id) {
			this.setState({ item: null });
			GetItem(`/pages/${this.props.match.params.id}`).then(data => {
				this.sanitizePageValues(data.data);
			});
		}
		return (
			<div className="ta-center">
				{this.state.item ? (
					<PagesForm
						cultures={this.props.cultures}
						onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler)}
						initialValues={this.state.item}
						buttonLabel={`Create ${this.label}`}
						getFormApi={this.props.getFormApi}
						hasFormApi={this.props.hasFormApi}
						setAppetizePageId={this.setAppetizePageId}
						setAppetizePause={this.setAppetizePause}
						appKey={this.props.appKey}
						isCopy
					/>
				) : (
					<Loader />
				)}
			</div>
		);
	};

	renderUpdateForm = () => {
		const { item, showPreview } = this.state;
		if (item === null) {
			GetItem(`/pages/${this.props.match.params.id}`).then(data => {
				this.sanitizePageValues(data.data);
			});
		} else if (item.id !== this.props.match.params.id) {
			this.setState({ item: null });
			GetItem(`/pages/${this.props.match.params.id}`).then(data => {
				this.sanitizePageValues(data.data);
			});
		}
		return (
			<div className="ta-center">
				{item ? (
					<PagesForm
						cultures={this.props.cultures}
						onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler, this.state.item.id)}
						initialValues={item}
						buttonLabel={`Update ${this.label}`}
						getFormApi={this.props.getFormApi}
						hasFormApi={this.props.hasFormApi}
						setAppetizePageId={this.setAppetizePageId}
						setAppetizePause={this.setAppetizePause}
						appKey={this.props.appKey}
						actionType="update"
						entity="pages"
						id={this.state.item.id}
					/>
				) : (
					<Loader />
				)}
			</div>
		);
	};

	sanitizePageValues = item => {
		if (item.moduleId) {
			const module = this.props.modules.modules.find(module => module.id === item.moduleId);
			if (module) {
				this.parseModuleProperties(module.properties, item.properties);
				this.setState({ item });
			} else {
				this.setState({ item });
			}
		} else {
			this.setState({ item });
		}
	};

	parseModuleProperties = (properties, item) => {
		const propertiesKeys = Object.keys(properties);
		const itemKeys = Object.keys(item);

		itemKeys.forEach(itemKey => {
			if (!propertiesKeys.includes(itemKey)) {
				delete item[itemKey];
			} else {
				if (properties[itemKey].type === "collection") {
					item[itemKey].forEach(newItem => {
						this.parseModuleProperties(properties[itemKey].items.properties, newItem);
					});
				} else if (properties[itemKey].type === "group") {
					this.parseModuleProperties(properties[itemKey].properties, item[itemKey]);
				}
			}
		});
	};

	setAppetizePageId = (appetizePageId, moduleId) => {
		if (this.state.appetizePageId === null) {
			const { appId } = this.state;
			this.setState({
				appetizePageId,
				appetizeParams: encodeURIComponent(
					`{"firestorePageDocumentName": "${appetizePageId}", "appId": "${appId}"}`
				),
			});
		}
		if (moduleId && this.state.moduleId !== moduleId) {
			this.setState({
				moduleId,
				showPreview: true,
			});
		} else if (!moduleId) {
			this.setState({
				moduleId,
				showPreview: false,
			});
		}
		if (this.iframe) {
			this.iframe.contentWindow.postMessage("heartbeat", "*");
		}
	};

	setAppetizePause = appetizePaused => {
		if (appetizePaused !== this.state.appetizePaused) {
			this.setState({ appetizePaused });
		}
	};

	previewContent = style => {
		const { appetizeParams, showPreview } = this.state;
		return (
			<div style={style}>
				<div className={`appetize-pause${this.state.appetizePaused ? " on" : ""}`}>
					<div className="appetize-pause-text">
						<i className="fal fa-pause-circle"></i>
						<div className="ta-center">Incomplete Data</div>
					</div>
				</div>
				{showPreview ? (
					<iframe
						ref={r => {
							this.iframe = r;
						}}
						targetorigin="apoc://"
						src={`https://appetize.io/embed/${constants.APPETIZE_PUBLIC_KEY}?device=iphone14pro&osVersion=26.0&scale=75&&autoplay=true&orientation=portrait&deviceColor=black&xdocMsg=true&params=${appetizeParams}`}
						width="323px"
						height="696px"
						frameBorder="0"
						scrolling="no"
						title="Your App Preview"
					/>
				) : (
					<div></div>
				)}
			</div>
		);
	};

	render() {
		let content = "Loading";
		switch (this.props.type) {
			case "new":
				content = this.renderCreateForm();
				break;
			case "copy":
				content = this.renderCopyForm();
				break;
			case "update":
				content = this.renderUpdateForm();
				break;
			default:
				break;
		}

		const { showPreview, responsivePreview } = this.state;

		return (
			<Page title="My Pages">
				{showPreview && (
					<div className="preview-button-container">
						<button
							title="Preview Page"
							className="btn btn-info btn-block"
							onClick={() => this.setState({ responsivePreview: true })}
						>
							Preview Page
						</button>
					</div>
				)}
				{responsivePreview ? (
					<div className={`coverall more global-coverall${responsivePreview ? " on" : ""}`}>
						<div className="global-preview absolute-center global pop-up-box">
							<div className="responsive-preview">
								<button
									title="Hide Preview"
									className="btn btn-info btn-block m-bottom"
									onClick={() => this.setState({ responsivePreview: false })}
								>
									Hide Preview
								</button>
								<div className="phone-preview">{this.previewContent()}</div>
							</div>
						</div>
					</div>
				) : (
					<div className="page-contents">
						<div className="page-builder">{content}</div>
						<div className="page-gutter" />
						<StickyContainer className="phone-preview">
							<Sticky topOffset={-60}>
								{({ style }) => {
									let newStyle = Object.assign({}, style, { top: (style.top ? style.top : 0) + 60 });
									return this.previewContent(newStyle);
								}}
							</Sticky>
						</StickyContainer>
					</div>
				)}
			</Page>
		);
	}
}

PageFormWrapper.propTypes = {
	appKey: PropTypes.string,
	apps: PropTypes.array,
	auth: PropTypes.object,
	clearFormApi: PropTypes.func,
	copyItem: PropTypes.func,
	createItem: PropTypes.func,
	cultures: PropTypes.array,
	formApi: PropTypes.object,
	getFormApi: PropTypes.func,
	hasFormApi: PropTypes.bool,
	hideLoading: PropTypes.func,
	items: PropTypes.array,
	match: PropTypes.object,
	modules: PropTypes.object,
	showLoading: PropTypes.func,
	type: PropTypes.string,
	updateItem: PropTypes.func,
};

export default withRouter(PageFormWrapper);
